import React from 'react';
import PropTypes from 'prop-types';

import CalendarModal from './integration_modals/calendar_modal';

import calendarIcon from './images/calendar_integration.svg';
import clickToCallIcon from './images/click_to_call.svg';

import IntegrationsApi from './integrations_api';
import AvailableIntegrationsCard from './available_integrations_card';
import ClickToCallRegistrationModal from 'components/click_to_call/registration_modal';

export default class AvailableIntegrations extends React.Component {
  static propTypes = {
    clickToCallIntegration: PropTypes.object,
    currentDatabase: PropTypes.shape({
      databaseId: PropTypes.number
    }).isRequired,
    currentUser: PropTypes.shape({
      calendarIntegrationAvailable: PropTypes.bool,
      clickToCallEnabled: PropTypes.bool
    }).isRequired,
    databases: PropTypes.array.isRequired,
    googleIntegration: PropTypes.object
  };

  state = {
    showCalendarModal: false,
    showClickToCallModal: false
  };

  api = new IntegrationsApi();

  handleShowCalendarModal = () => this.setState({ showCalendarModal: true });
  handleShowClickToCallModal = () => this.setState({ showClickToCallModal: true });
  handleCloseModals = () => this.setState({
    showCalendarModal: false,
    showClickToCallModal: false
  });

  handleFinishClickToCall = (success) => {
    this.handleCloseModals();

    if (success) {
      window.location.reload();
    }
  };

  handleSaveIntegration = (databaseId) => {
    this.api.beginGoogleIntegration(databaseId, this.props.currentUser.id).then((response) => {
      this.handleCloseModals();
      window.location.assign(response.data.redirect_url);
    });
  };

  render() {
    return (
      <React.Fragment>
        <p className="fs-large fw-semibold mt-6 mb-0">Available Integrations</p>
        {this.renderAvailableIntegrations()}
        {this.renderClickToCallModal()}
        {this.renderCalendarModal()}
      </React.Fragment>
    );
  }

  renderAvailableIntegrations() {
    const { clickToCallIntegration, currentDatabase, googleIntegration } = this.props;

    const calendarDatabaseId = googleIntegration ? googleIntegration.databaseId : null;

    if (calendarDatabaseId === currentDatabase.id && clickToCallIntegration) {
      return (
        <p className="fs-large text-muted mb-0">
          This database is currently using all available integrations
        </p>
      );
    } else {
      return (
        <React.Fragment>
          {this.renderCalendarBlock()}
          {this.renderClickToCallBlock()}
        </React.Fragment>
      );
    }
  }

  renderCalendarBlock() {
    const {
      currentDatabase,
      currentUser: { calendarIntegrationAvailable },
      googleIntegration,
      databases
    } = this.props;
    const databaseId = googleIntegration ? googleIntegration.databaseId : null;

    if (!calendarIntegrationAvailable || databaseId === currentDatabase.id) return;

    return (
      <AvailableIntegrationsCard
        currentDatabase={currentDatabase}
        databases={databases}
        image={calendarIcon}
        integration={googleIntegration}
        name="calendar"
        toolTipId="calendar-tooltip"
        onConnect={this.handleShowCalendarModal}
      >
        <div className="d-flex flex-column gap-1">
          <p className="mt-2 mb-0 fw-semibold">Calendar Sync</p>
          <div className="fs-large text-muted">
            Sync Buildout Calendar Events with your Google account
          </div>
        </div>
      </AvailableIntegrationsCard>
    );
  }

  renderClickToCallBlock() {
    const { clickToCallIntegration, currentDatabase, currentUser: { clickToCallEnabled }, databases } = this.props;

    if (clickToCallEnabled && clickToCallIntegration == null) {
      return (
        <AvailableIntegrationsCard
          currentDatabase={currentDatabase}
          databases={databases}
          image={clickToCallIcon}
          name="click-to-call"
          toolTipId="click-to-call-tooltip"
          onConnect={this.handleShowClickToCallModal}
        >
          <div className="d-flex flex-column gap-1">
            <p className="mt-2 mb-0 fw-semibold">Click-to-Call</p>
            <div className="fs-large text-muted">
              Connect your phone number to make calls directly from Buildout. Powered by Twilio
            </div>
          </div>
        </AvailableIntegrationsCard>
      );
    }
  }

  renderCalendarModal() {
    const { showCalendarModal } = this.state;
    const { databases } = this.props;

    return (
      <CalendarModal
        databases={databases}
        shown={showCalendarModal}
        onCancel={this.handleCloseModals}
        onSave={this.handleSaveIntegration}
      />
    );
  }

  renderClickToCallModal() {
    const { showClickToCallModal } = this.state;
    const { currentUser } = this.props;

    return (
      <ClickToCallRegistrationModal
        currentUser={currentUser}
        shown={showClickToCallModal}
        onClose={this.handleFinishClickToCall}
      />
    );
  }
}
